import { useProductCardActions } from 'hooks/useProductCardActions';
import Packing from 'model/Packing';
import ProductOffer from 'model/ProductOffer';

import { PackingTypeSale } from 'enums/packingTypeSale';
import { ProductCardCompact } from '../organisms/ProductCardCompact/ProductCardCompact';
import { ProductCardGrid } from '../organisms/ProductCardGrid/ProductCardGrid';
import { ProductCardList } from '../organisms/ProductCardList/ProductCardList';

export interface ProductCardTemplateProps {
  variant: 'grid' | 'list' | 'compact';
  product: ProductOffer;
  packingSelected: Packing;
  getLowPrice: number;
  showAdditionalIcon?: boolean;
  showPurchaseActions?: boolean;
  addInCart: (
    quantityPacking: number,
    selectedTypeSale: PackingTypeSale,
  ) => void | Promise<void>;
  selectedTypeSale?: PackingTypeSale;
  buy(
    quantityPacking: number,
    selectedTypeSale: PackingTypeSale,
  ): void | Promise<void>;
  showModalComposition: () => void;
  onSelectPacking?: (id: number) => void;
  isExclusiveOffer?: boolean;
}

export function ProductCardTemplate({
  variant,
  product,
  packingSelected,
  getLowPrice,
  showAdditionalIcon = true,
  showPurchaseActions = false,
  addInCart,
  selectedTypeSale,
  buy,
  showModalComposition,
  onSelectPacking,
  isExclusiveOffer = false,
}: ProductCardTemplateProps) {
  const { handleShowDetails } = useProductCardActions();

  const baseProps = {
    product,
    packingSelected,
    getLowPrice,
    onDetailsClick: () =>
      handleShowDetails(product, packingSelected, isExclusiveOffer),
    showIcons: showAdditionalIcon,
    disabled: false,
    showPurchaseActions,
    addInCart,
    selectedTypeSale,
    buy,
    showModalComposition,
    onSelectPacking,
    isExclusiveOffer,
  };

  switch (variant) {
    case 'grid':
      return <ProductCardGrid {...baseProps} />;

    case 'list':
      return <ProductCardList {...baseProps} />;

    case 'compact':
      return <ProductCardCompact {...baseProps} />;

    default:
      return <ProductCardGrid {...baseProps} />;
  }
}
